// src/utils/apiBase.js

// Use environment variable if available, otherwise fallback to relative path for production
const API_BASE = process.env.REACT_APP_API_BASE || '';

export default API_BASE;
